/* eslint-disable react-hooks/exhaustive-deps */
import { useAtom } from "jotai";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import DescButton from "./components/DescButton";
import Game from "./components/Game";
import GameEndModal from "./components/GameEndModal";
import Home from "./components/Home";
import Inventory from "./components/Inventory";
import Ranking from "./components/Ranking";
import TouchArea from "./components/TouchArea";
import { getMyBestScore, setMyBestScore } from "./db";
import { fireAuth } from "./firebase";
import { Background } from "./game-object/Background";
import { BigMonster } from "./game-object/BigMonster";
import { Floor } from "./game-object/Floor";
import { Hero } from "./game-object/Hero";
import { Monster } from "./game-object/Monster";
import { Sky } from "./game-object/Sky";
import { Star } from "./game-object/Star";
import { firebaseInitAtom, screenAtom, userAtom } from "./jotai/service";

const CANVAS_WIDTH = 350;
const CANVAS_HEIGHT = 600;

function App() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const requestRef = useRef<number>();
  const ctxRef = useRef<CanvasRenderingContext2D>();
  const monsterListRef = useRef<Monster[] | BigMonster[]>([]);
  const heroRef = useRef<Hero>();
  const timerRef = useRef<number>(0);
  const floorRef = useRef<Floor>();
  const skyRef = useRef<Sky>();
  const isEndRef = useRef<boolean>(false);
  const scoreRef = useRef<number>(0);
  const starListRef = useRef<Star[]>([]);
  const starCountRef = useRef<number>(0);
  const backgroundRef = useRef<Background>();
  const stageRef = useRef<number>(1);

  const [screen] = useAtom(screenAtom);

  const [firebaseInit, setFirebaseInit] = useAtom(firebaseInitAtom);
  const [user, setUser] = useAtom(userAtom);

  const heroMoveLeft = () => {
    const hero = heroRef.current;

    if (hero) {
      hero.status = "left";
    }
  };

  const heroMoveRight = () => {
    const hero = heroRef.current;

    if (hero) {
      hero.status = "right";
    }
  };

  const stopHero = () => {
    const hero = heroRef.current;

    if (hero) {
      hero.status = "stop";
    }
  };

  useEffect(() => {
    fireAuth.onAuthStateChanged((fireUser) => {
      setFirebaseInit(true);
      setUser({
        email: fireUser?.email,
        userName: fireUser?.displayName,
        nickName: "",
        photoURL: fireUser?.photoURL,
        uid: fireUser?.uid,
      });
    });

    heroRef.current = new Hero(CANVAS_WIDTH / 2 - 25, CANVAS_HEIGHT - 100);
    floorRef.current = new Floor(0, CANVAS_HEIGHT - 70, CANVAS_WIDTH, 100);
    skyRef.current = new Sky(0, 0, CANVAS_WIDTH, 650);
    backgroundRef.current = new Background(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

    window.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });

    window.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") {
        heroMoveRight();
      } else if (e.key === "ArrowLeft") {
        heroMoveLeft();
      }
    });

    window.addEventListener("keyup", (e) => {
      stopHero();
    });
  }, []);

  useEffect(() => {
    const asyncFunc = async () => {
      const localScore = localStorage.getItem("not-login-score");
      console.log(localScore);
      console.log(user);
      if (firebaseInit && user?.uid && localScore) {
        const info = await getMyBestScore(user);
        console.log(info);
        if (!info || +localScore > Number(info?.bestScore)) {
          await setMyBestScore(user, +localScore);
        }
      }
    };
    asyncFunc();
  }, [user]);

  if (screen === "Home") return <Home />;

  if (screen === "Ranking") return <Ranking />;

  if (screen === "Inventory") return <Inventory />;

  if (screen === "Game")
    return (
      <Container>
        <Game
          canvasRef={canvasRef}
          requestRef={requestRef}
          ctxRef={ctxRef}
          monsterListRef={monsterListRef}
          heroRef={heroRef}
          timerRef={timerRef}
          floorRef={floorRef}
          skyRef={skyRef}
          isEndRef={isEndRef}
          scoreRef={scoreRef}
          starListRef={starListRef}
          starCountRef={starCountRef}
          backgroundRef={backgroundRef}
          stageRef={stageRef}
        />
        <GameEndModal />

        <ButtonWrapper>
          <DescButton value="left" />
          <DescButton value="right" />
        </ButtonWrapper>

        <TouchWrapper>
          <TouchArea value="left" heroMove={heroMoveLeft} stopHero={stopHero} />
          <TouchArea
            value="right"
            heroMove={heroMoveRight}
            stopHero={stopHero}
          />
        </TouchWrapper>
      </Container>
    );

  return <></>;
}

export default App;

const Container = styled.div`
  margin: auto;

  max-width: 420px;
  height: 100vh;

  /* min-height: 650px; */
  /* background-color: pink; */

  position: relative;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 10px;

  position: absolute;
  bottom: 0;
  width: 100%;
`;

const TouchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 10px;

  position: absolute;
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
